import { SyntheticEvent, useState } from "react";
import TabbedPage from "../../components/TabbedPage";
import { BandCsvImportContent } from ".";
import { BookingCsvImportContent } from "./BookingsImport";

const CsvImportTabs = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleChange = (_event: SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  return (
    <TabbedPage
      title="CSV Importer"
      value={tabIndex}
      onChange={handleChange}
      tabs={[
        { label: "Bands", content: <BandCsvImportContent /> },
        { label: "Bookings", content: <BookingCsvImportContent /> },
      ]}
    />
  );
};

export default CsvImportTabs;
